// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"088142bb","455":"9e1bc553","977":"f33ba217"}[chunkId] + ".chunk.js";
};